import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { IButtonDirective, IIconComponent, ModalOptions, ModalRef } from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";

@Component({
  selector: "app-product-tour-welcome-modal",
  template: `
    <ng-container *transloco="let t">
      <div class="flex flex-col gap-5 p-3">
        <p class="type-body text-muted-foreground">{{ t("product-tour.welcome_intro") }}</p>
        <ul class="grid grid-cols-3 gap-3">
          <li class="flex flex-col gap-2 rounded-lg border p-4">
            <div class="type-body-medium text-foreground flex items-center gap-2">
              <IIcon name="target" class="text-main shrink-0" />{{ t("product-tour.product_goals_title") }}
            </div>
            <div class="type-body text-muted-foreground">{{ t("product-tour.product_goals_description") }}</div>
          </li>
          <li class="flex flex-col gap-2 rounded-lg border p-4">
            <div class="type-body-medium text-foreground flex items-center gap-2">
              <IIcon name="radio" class="text-main shrink-0" />{{ t("product-tour.full_funnel_title") }}
            </div>
            <div class="type-body text-muted-foreground">{{ t("product-tour.full_funnel_description") }}</div>
          </li>
          <li class="flex flex-col gap-2 rounded-lg border p-4">
            <div class="type-body-medium text-foreground flex items-center gap-2">
              <IIcon name="layoutGrid" class="text-main shrink-0" />{{ t("product-tour.reporting_title") }}
            </div>
            <div class="type-body text-muted-foreground">{{ t("product-tour.reporting_description") }}</div>
          </li>
        </ul>
      </div>
      <div class="modal-footer justify-between">
        <p class="type-body-medium text-muted-foreground">{{ t("product-tour.preview_note") }}</p>
        <button iButton (click)="ref.close()">{{ t("product-tour.start_exploring") }}</button>
      </div>
    </ng-container>
  `,
  imports: [TranslocoDirective, IButtonDirective, IIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductTourWelcomeModalComponent {
  static readonly defaultModalOptions: Omit<ModalOptions<unknown>, "data"> = { size: "lg", padding: "none" };

  protected readonly ref = inject(ModalRef);
}
